export function appendTestId(
  prefix: string | undefined,
  id: string | number | undefined
) {
  return prefix ? `${prefix}-${id}` : undefined;
}
